<template>
    <select class="form-control" :disabled="disabled" @change="handleSelectChange">
        <option v-for="folder in folderData" 
            :key="folder.id" 
            :value="folder.id" 
            :selected="folder.id === selected"
        >
            {{ folder.name }}
        </option>
        <option value="0" :selected="(current == 0 || selected == 0)">Root folder</option>
    </select>
</template>
<script>
import axios from 'axios'
const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "select-folder",
    props: {
        selected: {
            required: false,
            type: Number
        },
        current: {
            required: false,
            type: Number
        },
        disabled: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            folderData: []
        };
    },
    mounted() {
        let url = this.current ? 
            `${base_url}/pimapi/assets/folders?folder=${this.current}` : `${base_url}/pimapi/assets/folders`;

        axios.get(url)
        .then(function(response) {
                this.folderData = response.data.payload.sort(function(a, b) {
                    return a.name.localeCompare(b.name, undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    });
                });
            }.bind(this))
            .catch(function(err) {
                console.log(err);
                this.$emit('alert', {
                    message: 'Error loading folders',
                    status: 'alert-danger'
                });
            }.bind(this));
    },
    methods: {
        handleSelectChange(e) {            
            this.$emit('selection', parseInt(e.target.value));
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
